import React, { useState, useEffect } from 'react';
import ReactCompareImage from 'react-compare-image';
import GenericImage from './GenericImage';
import { createGATags, handleGAClick } from '../utils.js';
import { scrollToTopOf, segmentTrackEvent } from '../utils';

const Section = ({
    section,
    sectionIndex,
    season,
    handleClick,
    isMobile,
}) => {

    const [showSection, setShowSection] = useState(false);
    const [sticky, setSticky] = useState(false);
    const nextSection = ( sectionIndex === 3 ) ? 0 : sectionIndex + 1;
    const closeTracker = {
          module: 'section',
          category: 'close-section',
          linkType: 'close-section',
          label: `close-${season}`,
    };
    const sectionTracker = {
          module: 'section',
          category: 'open-section',
          linkType: 'open-section',
          label: `open-next-season-from-${section.season}`,
    };

    useEffect(() => {
        const handleScroll = () => {
            window.scrollY > 0 ? setSticky(true) : setSticky(false);
        }

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    },[sticky]);

    const subSections = section.subSections.map((subSection, i) => {
        const { level, title, img, body, products, credit, imgCompare, levelImg } = subSection;
        const imageComparisonSliderHandleSize = !isMobile ? 68 : 34;
        const sliderLineWidth = !isMobile ? 2 : 1;
        const trackingLabel = title + " hyperlink";
        const textLinkTracker = {
              destinationUrl: trackingLabel,
              module: 'section',
              category: 'text-link',
              linkType: 'text-link',
              label: trackingLabel,
        };
        const renderedProducts = products.map((product, i) => {
           const productTracker = {
              destinationUrl: product.link,
              module: 'section',
              category: 'data-link-type',
              linkType: 'data-link-type',
              label: product.link,
            };

             return (
                <div className="product" key={i} onClick={() => segmentTrackEvent("article_clicked", productTracker)}>
                    <a href={product.link} target="_blank" >
                        <img src={product.img} className="product-image"></img>
                    </a>
                    <h4 className="product-name" dangerouslySetInnerHTML={{ __html: product.name }}></h4>
                    <a href={product.link} target="_blank" className="product-cta">Buy Now</a>
                </div>
            )

        })
        return (
            <div className={`sub-section section-${i}`} id={i} key={i}>
                { isMobile && 
                    <div className="level-wrapper">
                        <img src={levelImg} className="level-image"></img>
                        <div className="sub-section-level">{level}</div>
                    </div>
                }
                <div className="sub-section-image-container">
                    { !imgCompare ? (
                       <img src={isMobile ? img : img} className="sub-section-image"></img>
                    ) : (
                        <div className="image-comparison-slider">
                        <ReactCompareImage 
                            leftImage={img}
                            rightImage={imgCompare}
                            handleSize={imageComparisonSliderHandleSize}
                            sliderLineWidth={sliderLineWidth} 
                            sliderLineColor="black"
                            handleColor="black"
                            handleBackgroundColor="white"/>
                        </div>
                    )}

                    <div className="sub-section-image-credit">{credit}</div>
                </div>
                <div className="sub-section-copy">
                    <div className="sub-section-copy-wrapper">
                        <h3 className="sub-section-subhed" dangerouslySetInnerHTML={{ __html: title }}></h3>
                        <div className="sub-section-title-line"></div>
                        <p className={`sub-section-copy-body section-${sectionIndex}`} 
                            dangerouslySetInnerHTML={{ __html: body }} onClick={() => segmentTrackEvent("article_clicked", textLinkTracker)}>    
                        </p>
                        <div className="products-section">
                            <h3 className="products-subhed">Get the Look:</h3>
                            <div className="products-wrapper">
                                {renderedProducts}
                            </div>
                        </div>
                    </div>
                </div>
                { !isMobile && 
                    <div className="level-wrapper">
                        <img src={levelImg} className="level-image"></img>
                        <div className="sub-section-level">{level}</div>
                    </div>
                }
            </div>  
        )
    })


	return (
		<div className="section-container">
            <div id="section" className={`section ${section.season}`}>
                <div className={`sub-section-container ${sticky ? 'sticky' : ''}`}>
                    <div className={`sub-section-hed-container ${section.season} ${sticky ? 'sticky' : ''}`}>
                        <h4 className="sub-section-season">{section.season}</h4>
                        <h2 className="sub-section-hed" dangerouslySetInnerHTML={{ __html: section.hed }}></h2>
                        <div className={`section-button-x section-${sectionIndex}`} onClick={() => {segmentTrackEvent("article_clicked", closeTracker); handleClick(null, true)}}></div>
                    </div>
                    {subSections}
                    <button className="next-section-cta" onClick={() => {segmentTrackEvent("article_clicked", sectionTracker); handleClick(nextSection, false)}}>Click to see the next season</button>
                </div> 
		    </div>
        </div>
	)
};

export default Section;